import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { appConfig } from './app-config';

// Get default language from app config
const defaultLanguage = appConfig?.localization?.default_language || 'pl';

console.log('i18n initializing with language:', defaultLanguage);

i18n
  .use(initReactI18next) 
  .init({
    resources: {
      en: {
        translation: require('./locales/en_EN/translation.json'), 
      },
      pl: {
        translation: require('./locales/pl_PL/translation.json'),
      },
    },
    lng: defaultLanguage,
    fallbackLng: 'pl',
    interpolation: {
      escapeValue: false,
    },
    debug: false, // Set to true to see i18n debug logs
  });

export default i18n;
